import * as BABYLON from "babylonjs";
import { Product } from "./Product";
import { Pingtai } from "./Pingtai";
import { copymesh, worldToScreen } from "../Tools/index.js";
import { rectLayout, fenceLayout } from "../Tools/layout";
import config from "../config";
export class Project {
  constructor(projectInfo) {
    this.mesh = BABYLON.MeshBuilder.CreateBox('project' + projectInfo.id, {});
    this.mesh.visibility = 0.0;
    this.projectInfo = projectInfo
    this.addAllObjs(projectInfo)
    // levelsShowIns.eventbus.$on('meshhide', this.hide, this);
    // let { z, x, campoi, lookat, fences } = rectLayout(
    //   this.mesh.getChildren(),
    //   config
    // );
    // this.initCameraCfg = { campoi, lookat };

  }
  addAllObjs(projectInfo){
    // levelsShowIns.scene.registerBeforeRender(this.addHotPoi);
    for (let index = 0; index < projectInfo.layout.length; index++) {
      const objinfo = projectInfo.layout[index];
        if(objinfo.level == 0){
          this.setProject(projectInfo.layout)
        }else{
          if(objinfo.meta.meshType == 'ground' ||objinfo.meta.meshType == '水泥台'){
            this.addPingtai(objinfo)
          }else{
            this.addProduct(objinfo)
          }
        }
        // if(objinfo.level == 1){
        //   this.addPingtai(objinfo)
        // }
        // if(objinfo.level == 2){
        //   this.addProduct(objinfo)
        // }
    }
  }
  setProject(layout){
    let r = 0
    for (let index = 0; index < layout.length; index++) {
      let x = Math.abs(layout[index].meta.x);
      let z = Math.abs(layout[index].meta.z);
      let _r = x>z?x:z
      if(_r>r)r = _r
    }
    if(r==0)r= 1
    let lookat = [0, 0, 0];
    let campoi = [r *2*1, r*2* .3 , r *2* 1];
    this.initCameraCfg = { campoi, lookat };
    levelsShowIns.camera.cameraGo(campoi,lookat, 500)
  }
  addPingtai(objinfo){
    let table = new Pingtai(objinfo)
    this.mesh.addChild(table.mesh);
  }
  addProduct(objinfo){
    let product = new Product(objinfo)
    this.mesh.addChild(product.mesh);
  }
  hide(p) {
    try {
      this.product1s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product2s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product3s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product4s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product5s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product6s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.product7s.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.powerBoxs.table.visibility = p.visibility;
    } catch (error) {}
    try {
      this.electricalBoxs.table.visibility = p.visibility;
    } catch (error) {}
  }
  // addToScene() {
  //   for (let index = 0; index < this.products.length; index++) {
  //     const mesh = this.products[index].mesh;
  //     console.log(mesh);
  //     levelsShowIns.scene.addMesh(mesh);
  //   }
  // }
  initProducts(meshs, cfg, meshtype,pbr) {
    if (meshs.length == 0) return false;
    let rows = cfg.rows;
    if (cfg.rows > meshs.length) rows = meshs.length;
    let width = config[meshtype].width * rows + config.padding * (rows + 1);
    let height = config.table.height;
    let depth =
      Math.ceil(meshs.length / rows) *
        (config[meshtype].depth + config.padding) +
      config.padding;
    let table = BABYLON.MeshBuilder.CreateBox("table" + meshtype, {
      width,
      height,
      depth
    });
    table.material = pbr;

    for (let index = 0; index < meshs.length; index++) {
      let x =
        (index % rows) * (config[meshtype].width + config.padding) -
        width / 2 +
        config[meshtype].width / 2 +
        config.padding;
      let z =
        Math.floor(index / rows) * (config[meshtype].depth + config.padding) -
        depth / 2 +
        config[meshtype].depth / 2 +
        config.padding;
      let product = new Product(meshs[index], meshtype);
      table.addChild(product.mesh);
      product.mesh.position.x += x;
      product.mesh.position.z += z;
      product.mesh.position.y += height / 2;
    }
    table.$$width = width;
    table.$$depth = depth;
    // table.visibility = 0.2

    // table.position.x += cfg.x
    // table.position.z += cfg.z
    this.mesh.addChild(table);
    return { table, width, depth };
  }
  addHotPoi() {
    let tablsInfo = []
    let pois = []
    if(!levelsShowIns.projectInfo) return false;
    for (let index = 0; index < levelsShowIns.projectInfo.layout.length; index++) {
      const _object = levelsShowIns.projectInfo.layout[index];
      if(_object.meta.meshType==='水泥台'){
        tablsInfo.push(_object)
        let point = new BABYLON.Vector3(_object.meta.x ,config.table.height,-_object.meta.z);
        let res = worldToScreen(
          point,
          levelsShowIns.camera,
          levelsShowIns.scene,
          levelsShowIns.engine
        );
        pois.push({
          show: res._z < 1 ? true : false,
          s : res._z,
          left: res._x,
          top: res._y,
          name: _object.meta.id ,
          nodeId:_object.id
        })
      }
    }
    levelsShowIns.eventbus.$emit('pois', pois);
  }
  destroy() {
    levelsShowIns.scene.unregisterBeforeRender(this.addHotPoi);
    this.mesh.dispose();
    try {
      levelsShowIns.activeIn.hide()
    } catch (error) {

    }

    // levelsShowIns.eventbus.$off('meshhide');
    // 长时间点击会有 没有销毁的状况
  }

}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/Project.js